module.exports = __webpack_public_path__ + "static/media/favourite-ico-active.be4a8e63.svg";